<template>
  <div class="salaries-content-group-ae-guide">
    <SalariesContentGroupHeader group-id="ae-guide" />
    <SalariesContentBlock group-id="ae-guide">
      <h3 slot="header" class="salaries-content-group-ae-guide__header">
        Jan 2022:
        <br class="keep" />
        AE Compensation
      </h3>
      <div slot="description2" class="salaries-content-group-ae-guide__description2">
        The salaries collected from AEs are split by Base Salary and OTE in USD. The median pay of
        <br />
        participants is presented as well as the 1st and 3rd quartile salaries.
        <br class="keep" />
        <br />
        Across 11,000+ sales teams, the
        <b>average compensation for AEs rose by 40% in 2021</b>
        and 17%
        <br />
        in just Q4 alone.
      </div>
      <div slot="table" class="salaries-content-group-ae-guide__table">
        <div class="salaries-content-group-ae-guide__table-col">
          <Table9Svg alt="Average AE Salaries: Base and OTE" class="salaries-content-group-ae-guide__table-img" />
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="ae-guide">
      <h3 slot="header" class="salaries-content-group-ae-guide__header">
        AE Salaries:
        <br class="keep" />
        By City
      </h3>
      <div slot="description2" class="salaries-content-group-ae-guide__description2">
        The top 3 cities with highest median pay for AEs are Chicago, SF / Bay Area, and Boston, with
        <br />
        OTEs above $200K+.
      </div>
      <div slot="table" class="salaries-content-group-ae-guide__table">
        <div class="salaries-content-group-ae-guide__table-col">
          <Table10Svg
            alt="Average AE Salaries: Base and OTE by city location"
            class="salaries-content-group-ae-guide__table-img"
          />
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="ae-guide">
      <h3 slot="header" class="salaries-content-group-ae-guide__header">
        AE Salaries:
        <br class="keep" />
        By Years of Experience
      </h3>
      <div slot="description2" class="salaries-content-group-ae-guide__description2">
        The average AE's pay doubles in the first 10 years of their career.
      </div>
      <div slot="table" class="salaries-content-group-ae-guide__table">
        <div class="salaries-content-group-ae-guide__table-col">
          <Table11Svg
            alt="Average AE Salaries: Base and OTE by years of experience"
            class="salaries-content-group-ae-guide__table-img"
          />
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="ae-guide">
      <h3 slot="header" class="salaries-content-group-ae-guide__header">AE Salary by Segment</h3>
      <div slot="description2" class="salaries-content-group-ae-guide__description2">
        On average, Enterprise Account Executives make nearly $200K in OTE, compared to their SMB
        <br />
        counterparts who make ~$120K in OTE.
      </div>
      <div slot="table" class="salaries-content-group-ae-guide__table">
        <div class="salaries-content-group-ae-guide__table-col">
          <Table12Svg
            alt="Average AE Salaries: Base and OTE by company size: SMB, Mid-Market, Enterprise"
            class="salaries-content-group-ae-guide__table-img"
          />
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="ae-guide">
      <h3 slot="header" class="salaries-content-group-ae-guide__header">Want to make over $250K?</h3>
      <div slot="description2" class="salaries-content-group-ae-guide__description2">
        According to our respondents it pays to learn sales methodology.
        <br class="keep" />
        Of the $250k+ earners 1/2 are trained in the Challenger method and MEDDIC and Sandler were
        <br />
        the most popular methods.
      </div>
      <div slot="table" class="salaries-content-group-ae-guide__table">
        <div class="salaries-content-group-ae-guide__table-col">
          <Table13Svg
            alt="learn sales methodology: Challenger, MEDDIC, Sandler, Spin Selling, Conceptual Selling, No formal training, Snap Selling"
            class="salaries-content-group-ae-guide__table-img salaries-content-group-ae-guide__table-img-13"
          />
        </div>
      </div>
    </SalariesContentBlock>
  </div>
</template>

<script>
import SalariesContentGroupHeader from './SalariesContentGroupHeader.vue';
import SalariesContentBlock from './SalariesContentBlock.vue';
import Table9Svg from './images/table9.vue.svg';
import Table12Svg from './images/table12.vue.svg';

export default {
  name: 'SalariesContentGroupAeGuide',
  components: {
    SalariesContentBlock,
    SalariesContentGroupHeader,
    Table9Svg,
    Table10Svg: () => import('@/components/Icon/Table10.vue'),
    Table11Svg: () => import('@/components/Icon/Table11.vue'),
    Table12Svg,
    Table13Svg: () => import('@/components/Icon/Table13.vue'),
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-group-ae-guide {
  &__header {
    background: linear-gradient(97.4deg, #5b264d 0%, #754e75 100%), linear-gradient(97.4deg, #5b2f4f 0%, #655865 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 8px;
  }

  &__description2 {
    margin-bottom: 32px;
  }

  &__table {
    display: flex;
    justify-content: space-between;
  }

  &__table-col {
    &:first-child {
      flex-grow: 1;
      display: flex;
      justify-content: space-between;
    }

    & + &:last-child {
      margin-left: 71px;
      flex-shrink: 0;
      flex-basis: 361px;
    }
  }

  &__table-img {
    border-radius: 16px;
    overflow: hidden;
    filter: drop-shadow(0 34px 56px rgba(0, 0, 0, 0.12));
    width: 100%;
    height: auto;

    @include mq('sm') {
      width: auto;
    }
  }

  &__table-text-header {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    margin-bottom: 8px;
    background: linear-gradient(87.2deg, #1b447f -9.58%, #5f86d1 104.83%), linear-gradient(0deg, #fff, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &__table-text + &__table-text-header {
    margin-top: 32px;
  }

  &__table-text {
    font-size: 16px;
    line-height: 30px;
    color: #45454a;
  }

  &__table-img-13 {
    width: 100%;
    height: auto;

    @include mq('lg') {
      width: auto;
    }
  }
}
</style>
